


import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import syncTaggingUtility from "@sparta.global-vtim.utilities/sync-tagging-utility/dist/es6.js"
import ahVendorWrapperUtility from "@sparta.authglobal.utilities/ah-vendor-wrapper-utility/dist/es6.js"



window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global-gt.modules/global-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/global-gt-global-footer-module-es6" */ "@sparta.global-gt.modules/global-footer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/global-gt-global-footer-module-styles" */ "@sparta.global-gt.modules/global-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.modules/global-social-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/global-global-social-module-es6" */ "@sparta.global.modules/global-social-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/global-global-social-module-styles" */ "@sparta.global.modules/global-social-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global-tenants.modules/gt-nav-unauth-search-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/global-tenants-gt-nav-unauth-search-module-es6" */ "@sparta.global-tenants.modules/gt-nav-unauth-search-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/global-tenants-gt-nav-unauth-search-module-styles" */ "@sparta.global-tenants.modules/gt-nav-unauth-search-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.sales.modules/eyebrow-banner-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-es6" */ "@sparta.sales.modules/eyebrow-banner-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/sales-eyebrow-banner-module-styles" */ "@sparta.sales.modules/eyebrow-banner-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/header-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-header-module-es6" */ "@sparta.merrilledge.modules/header-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-header-module-styles" */ "@sparta.merrilledge.modules/header-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/nav-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-nav-module-es6" */ "@sparta.merrilledge.modules/nav-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-nav-module-styles" */ "@sparta.merrilledge.modules/nav-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/footnotes-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-footnotes-module-es6" */ "@sparta.merrilledge.modules/footnotes-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-footnotes-module-styles" */ "@sparta.merrilledge.modules/footnotes-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/masthead-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-masthead-module-es6" */ "@sparta.merrilledge.modules/masthead-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-masthead-module-styles" */ "@sparta.merrilledge.modules/masthead-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/stock-global-index-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-stock-global-index-module-es6" */ "@sparta.merrilledge.modules/stock-global-index-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-stock-global-index-module-styles" */ "@sparta.merrilledge.modules/stock-global-index-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/merrill-modal-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-merrill-modal-module-es6" */ "@sparta.merrilledge.modules/merrill-modal-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-merrill-modal-module-styles" */ "@sparta.merrilledge.modules/merrill-modal-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/merrilledge-common-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-merrilledge-common-module-es6" */ "@sparta.merrilledge.modules/merrilledge-common-module/dist/es6.js" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/quick-ticket-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-quick-ticket-module-es6" */ "@sparta.merrilledge.modules/quick-ticket-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-quick-ticket-module-styles" */ "@sparta.merrilledge.modules/quick-ticket-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/retirement-calculator-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-retirement-calculator-module-es6" */ "@sparta.merrilledge.modules/retirement-calculator-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-retirement-calculator-module-styles" */ "@sparta.merrilledge.modules/retirement-calculator-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/find-the-investing",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-find-the-investing-es6" */ "@sparta.merrilledge.modules/find-the-investing/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-find-the-investing-styles" */ "@sparta.merrilledge.modules/find-the-investing/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/support-guidance-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-support-guidance-module-es6" */ "@sparta.merrilledge.modules/support-guidance-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-support-guidance-module-styles" */ "@sparta.merrilledge.modules/support-guidance-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/investing-and-banking-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-investing-and-banking-module-es6" */ "@sparta.merrilledge.modules/investing-and-banking-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-investing-and-banking-module-styles" */ "@sparta.merrilledge.modules/investing-and-banking-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/accolade-reviews-section-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-accolade-reviews-section-module-es6" */ "@sparta.merrilledge.modules/accolade-reviews-section-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-accolade-reviews-section-module-styles" */ "@sparta.merrilledge.modules/accolade-reviews-section-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/ready-to-get-started-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-ready-to-get-started-module-es6" */ "@sparta.merrilledge.modules/ready-to-get-started-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-ready-to-get-started-module-styles" */ "@sparta.merrilledge.modules/ready-to-get-started-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/connect-with-advisor-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-connect-with-advisor-module-es6" */ "@sparta.merrilledge.modules/connect-with-advisor-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-connect-with-advisor-module-styles" */ "@sparta.merrilledge.modules/connect-with-advisor-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/your-money-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-your-money-module-es6" */ "@sparta.merrilledge.modules/your-money-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-your-money-module-styles" */ "@sparta.merrilledge.modules/your-money-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/bonus-offer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-bonus-offer-module-es6" */ "@sparta.merrilledge.modules/bonus-offer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-bonus-offer-module-styles" */ "@sparta.merrilledge.modules/bonus-offer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.merrilledge.modules/fifa-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-fifa-module-es6" */ "@sparta.merrilledge.modules/fifa-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/merrilledge-fifa-module-styles" */ "@sparta.merrilledge.modules/fifa-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.global-tenants.shared-components/gt-nav-auth-search",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-nav-auth-search-es6" */ "@sparta.global-tenants.shared-components/gt-nav-auth-search/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-card",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-card-es6" */ "@sparta.global.shared-components/spa-vue-card/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-svg",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-svg-es6" */ "@sparta.global.shared-components/spa-vue-svg/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-badging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-badging-es6" */ "@sparta.global.shared-components/spa-vue-badging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-modal",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-modal-es6" */ "@sparta.global.shared-components/spa-vue-modal/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-ui-layers",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-ui-layers-es6" */ "@sparta.global.shared-components/spa-vue-ui-layers/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-button",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-button-es6" */ "@sparta.global.shared-components/spa-vue-button/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-input-parts",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-input-parts-es6" */ "@sparta.global.shared-components/spa-vue-input-parts/dist/es6.js" )}
    }
  ],
  jcrs: [
    {
      name: "shared/global-tenants/en/unauth/gt-unauth-global.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/shared-global-tenants-en-unauth-gt-unauth-global.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/shared-global-tenants-en-unauth-gt-unauth-global-en-T1785928483789.json" )}
    },
    {
      name: "shared/global-tenants/en/unauth/gt-unauth-mocks.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/shared-global-tenants-en-unauth-gt-unauth-mocks.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/shared-global-tenants-en-unauth-gt-unauth-mocks-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/eyebrow-banner/eyebrow-banner.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-eyebrow-banner-eyebrow-banner.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-eyebrow-banner-eyebrow-banner-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/bootstrap-module/en/spinner-data.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-bootstrap-module-en-spinner-data.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-bootstrap-module-en-spinner-data-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/bootstrap-module/en/chat.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-bootstrap-module-en-chat.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-bootstrap-module-en-chat-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/header-module/header-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-header-module-header-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-header-module-header-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/nav-module/nav-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-nav-module-nav-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-nav-module-nav-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/nav-module/help-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-nav-module-help-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-nav-module-help-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/nav-module/mobile-nav.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-nav-module-mobile-nav.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-nav-module-mobile-nav-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/retirement-calculator-module/retirement-calculator-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-retirement-calculator-module-retirement-calculator-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-retirement-calculator-module-retirement-calculator-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/nav-module/modal-popup.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-nav-module-modal-popup.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-nav-module-modal-popup-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/investing-and-banking-module/investing-and-banking-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-investing-and-banking-module-investing-and-banking-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-investing-and-banking-module-investing-and-banking-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/find-the-investing-module/find-the-investing.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-find-the-investing-module-find-the-investing.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-find-the-investing-module-find-the-investing-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/support-guidance-module/support-guidance.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-support-guidance-module-support-guidance.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-support-guidance-module-support-guidance-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/accolade-reviews-section-module/accolade-reviews-section-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-accolade-reviews-section-module-accolade-reviews-section-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-accolade-reviews-section-module-accolade-reviews-section-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/connect-with-advisor/connect-with-advisor.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-connect-with-advisor-connect-with-advisor.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-connect-with-advisor-connect-with-advisor-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/your-money-module/your-money.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-your-money-module-your-money.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-your-money-module-your-money-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/ready-to-get-started-module/ready-to-get-started-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-ready-to-get-started-module-ready-to-get-started-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-ready-to-get-started-module-ready-to-get-started-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/connect-with-advisor/connect-with-advisor.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-connect-with-advisor-connect-with-advisor.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-connect-with-advisor-connect-with-advisor-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/masthead-module/masthead.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-masthead-module-masthead.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-masthead-module-masthead-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/footnotes-module/footnotes.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-footnotes-module-footnotes.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-footnotes-module-footnotes-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/footer/broker-check.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-footer-broker-check.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-footer-broker-check-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/footer/footer-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-footer-footer-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-footer-footer-module-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/footer/global-footer.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-footer-global-footer.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-footer-global-footer-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/footer/social.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-footer-social.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-footer-social-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/bonus-offer-module/bonus-offer.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-bonus-offer-module-bonus-offer.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-bonus-offer-module-bonus-offer-en-T1785928483789.json" )}
    },
    {
      name: "site/merrilledge-homepage/module-specific-v2/fifa-module/fifa-module.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-merrilledge-homepage-module-specific-v2-fifa-module-fifa-module.json" */ "file:///apps/wt/deploy/tmp/8B307F0A/build/dev3/site/merrilledge/spa-assets/data/site-merrilledge-homepage-module-specific-v2-fifa-module-fifa-module-en-T1785928483789.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
ahVendorWrapperUtility.init();
  console.log('after - execute boot functions')
})();
